import { Form, type FormInstance } from '@arco-design/web-react';
import get from 'lodash/get';

import { normalizeQuantityUnit, resolveDisplayUnit } from './resolve';

/**
 * 监听厂商设备选型上的 quantityUnit，并按计价/直建规则决议展示单位。
 * 直建且不传 vendorDevicePrefix 时走 resolveDisplayUnit（可用 omitWhenDirect）。
 * 存储类可传 lockDisplayToDefault，固定展示 defaultUnit（Gi）。
 */
export function useWatchedQuantityUnit(
  form: FormInstance,
  vendorDevicePrefix: string | undefined,
  defaultUnit: string,
  options?: {
    pricing?: boolean;
    directLabel?: string;
    omitWhenDirect?: boolean;
    /** 存储类：展示固定 Gi，忽略选型 quantityUnit */
    lockDisplayToDefault?: boolean;
  },
): string {
  const pricing = options?.pricing ?? Boolean(vendorDevicePrefix);
  const meta = Form.useWatch(vendorDevicePrefix, form) as Record<string, unknown> | undefined;
  const leaf = Form.useWatch(vendorDevicePrefix ? `${vendorDevicePrefix}.quantityUnit` : undefined, form);

  const quantityUnit = vendorDevicePrefix
    ? normalizeQuantityUnit(leaf) || normalizeQuantityUnit(meta?.quantityUnit ?? get(meta, 'quantityUnit'))
    : undefined;

  return (
    resolveDisplayUnit({
      quantityUnit,
      pricing,
      defaultUnit,
      directLabel: options?.directLabel,
      omitWhenDirect: options?.omitWhenDirect,
      lockDisplayToDefault: options?.lockDisplayToDefault,
    }) || defaultUnit
  );
}
